import { TextTIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Text = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <TextTIcon {...rest} size={Sizes[size]} height={Sizes[size]} color={fill} />;
};

Text.displayName = 'Text';
